

$.widget("bluaul.vcClockTimer",
    {

        self: null,
        isInput: false,

// ReSharper disable once UnusedParameter
        options: {
            width: 0, height: 0, twoLine: true, thirtyMin: false, multiState: false, showLegend: true,
            tooltips:["on","off","active"],
            callback: function (e) { }
        },

        _create: function() {
            var me = this;
            var i;
          
            var markStartID = -1;
            var markEndID = -1;

           this.isInput = me.element.is("input");
            if (this.options.width ===0) {
                this.options.width = parseInt(me.element.innerWidth());
            }
           

            if (this.options.height === 0) {
                if (this.options.twoLine) {
                    this.options.height = 78;
                } else {
                    this.options.height = 38;

                }
            }
            me.element.hide();


            //create a main Div holder for the extra elements
            var x = Math.random();

            var mainDiv = $("<div>")
                .attr("id", '_clock' + x)
                .css("width", this.options.width)
               
                .attr("class", "clocktimer");
       
          
            var val = "";
            val = this._getValue();
            if (val.length === 0 || val === "1") {
                if (me.options.thirtyMin === false) {
                    val = "111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111";
                } else {
                    val = "11111111111111111111111111111111111111111111111111";
                }
                me._setValue(val);
            } else if (val === "0") {
                if (me.options.thirtyMin === false) {
                    val =  "000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
                } else {
                    val = "000000000000000000000000000000000000000000000000";
                }
            } else {
                if (!(val.length === 96 || val.length === 48)) { mainDiv.html("error - invalid clock values length!"); val = ""; }
            }
        
            if (val.length > 0) {
                var sHtml = ""; var h = 0; var min = 0; var time = "";
                sHtml += "<div style='position:relative;height:";
                if (me.options.showLegend) { sHtml += '38' } else {sHtml += "18"}
                sHtml += "px'>";
                if (me.options.showLegend) { sHtml += "<span class='clinfo'>" + h + "h</span>";}

                var max, inc,  breakLine;
                if (me.options.thirtyMin === false) {
                    max = 96;
                    inc = 15;
                    breakLine = 47;
                } else {
                    max = 48;
                    inc = 30;
                    breakLine = 23;
                }


                for (i = 0; i < max; i++) {
                    min += inc;
                    if (min === 60) { h += 1; min = 0; }
                    sHtml += "<div id='cl" + i + "' class='";
                    switch (val.charAt(i)) {
                        case "0": sHtml += "cl cl0"; break;
                        case "1": sHtml += "cl cl1"; break;
                        case "2": sHtml += "cl cl2"; break;
                        default: sHtml += "cl clerr"; break;
                    }
                    sHtml += "'";
                    if (h.length === 1) { time = "0" + h } else { time = h };
                    time += ":";
                    if (min === 0) { time += "00" } else { time += min };
                    sHtml += " title='" + time + " h'></div>";
                    if (me.options.showLegend) {
                        if (this.options.twoLine) {
                            if (i === breakLine) {
                                sHtml += "</div>";
                                sHtml += "<div style='position:relative;height:";
                                if (me.options.showLegend) { sHtml += '38' } else { sHtml += "18" }
                                sHtml += "px'><span class='clinfo'>" +
                                    h + "h</span>";
                            }
                        }
                    }

                    if (min === 0 && h % 2 === 0) {
                            if ((h !== 12 || this.options.twoLine === false) && h < 24) {
                                sHtml += "<span class='break'>|</span>";
                                if (me.options.showLegend) {
                                    sHtml += "<span class='clinfo'>" + h + "h</span>";
                                }
                            }
                        }
                    }
                
                sHtml += "</div>";


                sHtml += "<div id='clockhelp' ><div class='cl cl1 '></div> " + this.options.tooltips[0] + " <div class='cl cl0'></div> " + this.options.tooltips[1] + " ";

                if (this.options.multiState) { sHtml += "<div class='cl cl2'></div> " + this.options.tooltips[2] + " "; }
                    sHtml += " | ALT + click = mark time range ";
                    sHtml += "</div>";
                    mainDiv.html(sHtml);
                    var w = 8;
                    if (this.options.twoLine) {
                        w = (100 / (max/2)) -0.57;
                    } else {
                        w = (100 / max) - 0.35;
                }


                    mainDiv.find(".cl").css("width", w + "%");
                }
                mainDiv.insertAfter(me.element);

                mainDiv.hover(function () { mainDiv.find("#clockhelp").show() }, function () { mainDiv.find("#clockhelp").hide(); });

                mainDiv.find(".cl").unbind("click").click(function (e) {
                
                var timer;
                var val;
                if (e.altKey) {
                    if (markStartID === -1) {
                        $(this).addClass("mark");
                        markStartID = parseInt($(this).attr("id").replace('cl', ''));
                    } else {
                        var startTag = mainDiv.find("#cl" + markStartID);
                        startTag.removeClass("mark");
                        var state = startTag.attr("class");
                        markEndID = parseInt($(this).attr("id").replace('cl', ''));
                        timer = me._getValue();
                        val = -1;
                        if (startTag.hasClass("cl0") || startTag.hasClass("clerr")) {val = 0; } 
                        if (startTag.hasClass("cl1")) { val = 1;} 
                        if (startTag.hasClass("cl2")) {val = 2;}

                        if (markEndID < markStartID) {
                            var tmp = markStartID;
                            markStartID = markEndID;
                            markEndID = tmp;
                            tmp = null;
                        }
                        for (i = markStartID; i <= markEndID; i++) {
                            mainDiv.find("#cl" + i).attr("class", state);
                            timer = timer.substring(0, i) + val + timer.substring(i + 1);
                            me._setValue(timer);
                        }
                        markStartID = -1;
                        markEndID = -1;
                        startTag = null; timer = null; val = null; state = null;
                    }
                } else {
                    markStartID = -1; markEndID = -1;
                    var singleTag = $(this);
                    val = -1;
                  
                    if (singleTag.hasClass("cl0") || singleTag.hasClass("clerr")) {
                        singleTag.removeClass("cl0").removeClass("clerr").addClass("cl1");
                        val = 1;
                    } else {
                        if (me.options.multiState) {
                            if (singleTag.hasClass("cl1")) {
                                singleTag.removeClass("cl1").addClass("cl2");
                                val = 2;
                            } else {
                                if (singleTag.hasClass("cl2")) {
                                    singleTag.removeClass("cl2").addClass("cl0");
                                    val = 0;
                                }
                            }
                        } else {
                            singleTag.removeClass("cl1").addClass("cl0");
                            val = 0;
                        }
                    }
                    var index = parseInt(singleTag.attr("id").replace('cl', ''));
                    timer = me._getValue();
                    timer = timer.substring(0, index) + val + timer.substring(index + 1);

                    me._setValue(timer);
                    }
                   
                me.options.callback(me);
            });
        },

        _getValue: function() {
            if (this.isInput) {
                return this.element.val();
            } else {
                return this.element.html();
            }
        },

        _setValue: function (val) {
            if (this.isInput) {
                this.element.val(val);
            } else {
               this.element.html(val);
            }
        },


        _destroy: function () {
            this.element
                .removeClass("vc-clock-timer")
                .html("");
        }

    });

